import React, { useContext } from "react";

import { ContextVar } from "./Context.jsx";

// stacks
import SiteStack from "./stack/SiteStack";

// images
import pmdriveinLogo from "./assets/pmdrivein.PNG";

export default function SiteNavigator() {
  const { isLoading } = useContext(ContextVar);

  if (isLoading) {
    return (
      <div
        style={{
          height: "80vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <>
          <style>
            {`
          .logo {
            height: 300px;
            width: 300px;
            border-radius: 10px;
          }

          @media (max-width: 425px) {
            .logo {
              height: 150px;
              width: 150px;
            }
          }
        `}
          </style>

          <img src={pmdriveinLogo} alt="PM DriveIn" className="logo" />
          <p>Loading...</p>
        </>
      </div>
    );
  }

  return <SiteStack />;
}
